import React from 'react';
import PropTypes from 'prop-types';
import { useTimeFrameFilter } from './useTimeFrameFilter';
import { useTranslation } from 'react-i18next';
import DateRangeModal from './DateRangeModal/DateRangeModal';
import PopoverUniselectSystem from '../DesignSystem/PopoverUniselectSystem';
import TruncatedTextSystem from '../DesignSystem/TruncatedTextSystem';
import TooltipSystemV2 from '../DesignSystem/TooltipSystemV2';
import { ArrowDropdownIcon } from '../../icons';
import { Colors } from '../../constants/colors.constants';
import './TimeFrameFilter.scss';

const { BLACK } = Colors;
const POPOVER_WIDTH = 168;
const POPOVER_COUNT_ITEMS_SHOW = 10;
const MAX_WIDTH_TRUNCATED_TEXT = 108;

const TimeFrameFilter = ({ toogleActivityTreePane }) => {
  const { t } = useTranslation();

  const {
    optionsPopoverRef,
    isDateRangeModalOpen,
    selectedItem,
    rollingStatus,
    getItemsPopover,
    setIsDateRangeModalOpen
  } = useTimeFrameFilter(toogleActivityTreePane);

  return (
    <>
      <PopoverUniselectSystem
        itemReference={optionsPopoverRef}
        width={POPOVER_WIDTH}
        countItemsShow={POPOVER_COUNT_ITEMS_SHOW}
        trigger="click"
        placement="bottomLeft"
        ctaText={t('lookahead_visualizationOpt.popover_cta_text')}
        items={getItemsPopover()}
        withSearch={false}>
        <div className="select-view-popover">
          <div className="select-view-popover__left">
            <TruncatedTextSystem
              maxWidth={MAX_WIDTH_TRUNCATED_TEXT}
              color={BLACK}
              placement="topLeft">
              <span>
                {t(
                  `lookahead_visualizationOpt.time_frame_filter_${selectedItem}`
                )}
              </span>
            </TruncatedTextSystem>
          </div>
          <div className="select-view-popover__right">
            <div className="right__rolling">
              <TooltipSystemV2
                placement="top"
                title={t(
                  `lookahead_visualizationOpt.time_frame_rolling_tooltip_${rollingStatus}`
                )}>
                <div className={`rolling__icon ${rollingStatus}`} />
              </TooltipSystemV2>
            </div>
            <ArrowDropdownIcon />
          </div>
        </div>
      </PopoverUniselectSystem>
      <DateRangeModal
        isDateRangeModalVisible={isDateRangeModalOpen}
        setIsDateRangeModalVisible={setIsDateRangeModalOpen}
      />
    </>
  );
};

TimeFrameFilter.propTypes = {
  toogleActivityTreePane: PropTypes.func
};

export default TimeFrameFilter;
